import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { TreeNode } from '../misc/interface/treenode';

@Injectable({
  providedIn: 'root'
})
export class OrgUnitsService {
  treedata: TreeNode[] = [];

  ouChilds: any;
  ouChilds_removeInactive: any;

  constructor(private dataService: DataService) { }

  getTimeForRequest(now: Date) {
    // Get the current date and time
    // const now = new Date();

    // Get the timezone offset in minutes
    const offsetMinutes = now.getTimezoneOffset();

    // Convert the current time to GMT+00:00
    const gmtTime = new Date(now.getTime() - (offsetMinutes * 60 * 1000));

    // Format the GMT time
    const formattedGMT = gmtTime.toISOString(); // This will give you a string in ISO format


    return formattedGMT
  }

  getEndOfWeek(selectedDate: Date) {
    // Clone the selected date to avoid modifying the original
    const endDate = selectedDate;

    // Calculate the difference between the current day and the end of the week
    const dayOfWeek = endDate.getDay();
    let diff: number = 0;
    // if(dayOfWeek > 6){
    //    diff = dayOfWeek === 0 ? 0 : 14 - dayOfWeek;
    // }
    // else 
    diff = dayOfWeek === 0 ? 7 : 7 - dayOfWeek;

    // Set the date to the end of the week
    endDate.setDate(endDate.getDate() + diff);

    // Set hours, minutes, seconds, and milliseconds to the end of the day
    endDate.setHours(23, 59, 59, 999);

    return endDate;
  }

  async getOrgUnits(): Promise<any> {
    console.log('OU_NAME_TREE')
    if (this.treedata.length > 0) {
      console.log('OU_NAME_TREE', this.treedata);
      return Promise.resolve(this.treedata);
    }
    try {
      if (this.ouChilds_removeInactive == undefined) {
        this.ouChilds_removeInactive = await this.dataService.getData(`ou/ouChilds?removeInactive=true`);
      }
      const response = this.ouChilds_removeInactive;

      console.log('TREEeeeeee', response.data)

      if (response.error) return
      var treedata: TreeNode[] = [];

      var level1 = response.data;

      var _ou_type: { [key: string]: any } = {};

      const types = await this.dataService.getData("ou-type");

      types.data.forEach((type: any) => {
        if (type.tag == "Ministries/Entities") {
          _ou_type[type.name] = {
            _id: type._id,
            id: null,
            label: type.name,
            data: type.icon,
            tag: type.tag,
            expanded: false,
            children: []
          }
        }
      })

      console.log("ou types", _ou_type);


      level1.forEach((item: any) => {
        if (item.type) {
          if (!_ou_type[item.type.name]) {
            _ou_type[item.type.name] = {
              _id: item.type._id,
              label: item.type.name,
              data: item.type.icon,
              tag: item?.type?.tag,
              expanded: false,
              children: [
                {
                  _id: item._id,
                  id: item.id,
                  label: item?.type?.tag == 'Branches' ? `${item.name} (${item?.location?.name})` : item.name,
                  data: item.image_sq,
                  tag: item?.type?.tag,
                  active: item?.active,
                  children: this.filterChildrens(item?.children, item._id),
                },
              ],
            };
          } else {
            _ou_type[item.type.name].children.push({
              _id: item._id,
              id: item.id,
              label: item?.type?.tag == 'Branches' ? `${item.name} (${item?.location?.name})` : item.name,
              data: item.image_sq,
              tag: item?.type?.tag,
              active: item?.active,
              children: this.filterChildrens(item?.children, item._id),
            });
          }
        }
      });

      var firstNode: { label: string; expanded: boolean; tag: string; data: string; children: any[] } = {
        label: "الجهات المشاركة",
        expanded: false,
        tag: 'Organisational Units',
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [],
      };

      for (const key in _ou_type) {
        if (_ou_type.hasOwnProperty(key)) {
          // Use the key and access the corresponding value
          if (_ou_type[key]) {
            firstNode.children.push(_ou_type[key]);
            console.log(`Key: ${key}, Value: ${_ou_type[key]}`);
          }
        }
      }

      treedata = [firstNode]
      this.treedata = treedata;

      console.log("TREEeeeeee", treedata)
      return treedata

    } catch (error) {
      console.log(error)
    }
  }

  async getOrgUnitsWithInactive(): Promise<any> {
    console.log('OU_NAME_TREE')
    if (this.treedata.length > 0) {
      console.log('OU_NAME_TREE', this.treedata);
      return Promise.resolve(this.treedata);
    }
    try {
      if (this.ouChilds == undefined) {
        this.ouChilds = await this.dataService.getData(`ou/ouChilds`);
      }

      const response = this.ouChilds

      console.log('TREEeeeeee', response.data)

      if (response.error) return
      var treedata: TreeNode[] = [];

      var level1 = response.data;

      var _ou_type: { [key: string]: any } = {};

      const types = await this.dataService.getData("ou-type");

      types.data.forEach((type: any) => {
        if (type.tag == "Ministries/Entities") {
          _ou_type[type.name] = {
            _id: type._id,
            id: null,
            label: type.name,
            data: type.icon,
            tag: type.tag,
            expanded: false,
            children: []
          }
        }
      })

      console.log("ou types", _ou_type);


      level1.forEach((item: any) => {
        if (item.type) {
          if (!_ou_type[item.type.name]) {
            _ou_type[item.type.name] = {
              _id: item.type._id,
              label: item.type.name,
              data: item.type.icon,
              tag: item?.type?.tag,
              expanded: false,
              children: [
                {
                  _id: item._id,
                  id: item.id,
                  label: item?.type?.tag == 'Branches' ? `${item.name} (${item?.location?.name})` : item.name,
                  data: item.image_sq,
                  tag: item?.type?.tag,
                  active: item?.active,
                  children: this.filterChildrens(item?.children, item._id),
                },
              ],
            };
          } else {
            _ou_type[item.type.name].children.push({
              _id: item._id,
              id: item.id,
              label: item?.type?.tag == 'Branches' ? `${item.name} (${item?.location?.name})` : item.name,
              data: item.image_sq,
              tag: item?.type?.tag,
              active: item?.active,
              children: this.filterChildrens(item?.children, item._id),
            });
          }
        }
      });

      var firstNode: { label: string; expanded: boolean; tag: string; data: string; children: any[] } = {
        label: "الجهات المشاركة",
        expanded: false,
        tag: 'Organisational Units',
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [],
      };

      for (const key in _ou_type) {
        if (_ou_type.hasOwnProperty(key)) {
          // Use the key and access the corresponding value
          if (_ou_type[key]) {
            firstNode.children.push(_ou_type[key]);
            console.log(`Key: ${key}, Value: ${_ou_type[key]}`);
          }
        }
      }

      treedata = [firstNode]
      this.treedata = treedata;

      console.log("TREEeeeeee", treedata)
      return treedata

    } catch (error) {
      console.log(error)
    }
  }

  async getOrgUnitsWithTagsFilter(tags: any[]): Promise<any> {
    try {
      if (this.ouChilds_removeInactive == undefined) {
        this.ouChilds_removeInactive = await this.dataService.getData(`ou/ouChilds?removeInactive=true`);
      }
      const response = this.ouChilds_removeInactive;

      if (response.error) return
      var treedata: TreeNode[] = [];

      var level1 = response.data;

      var _ou_type: { [key: string]: any } = {};

      const types = await this.dataService.getData("ou-type");

      types.data.forEach((type: any) => {
        if (type.tag == "Ministries/Entities") {
          _ou_type[type.name] = {
            _id: type._id,
            id: null,
            label: type.name,
            data: type.icon,
            tag: type.tag,
            expanded: false,
            children: []
          }
        }
      })

      console.log("ou types", _ou_type);

      level1.forEach((item: any) => {
        if (item.type) {
          if (item?.type?.tag == "Ministries/Entities") {

            if (!_ou_type[item.type.name]) {
              _ou_type[item.type.name] = {
                _id: item.type._id,
                label: item.type.name,
                data: item.type.icon,
                tag: item?.type?.tag,
                expanded: false,
                children: [
                  {
                    _id: item._id,
                    id: item.id,
                    label: item.name,
                    data: item.image_sq,
                    tag: item?.type?.tag,
                    active: item?.active,
                    children: this.filterChildrensWihFilter(item?.children, item._id, tags),
                  },
                ],
              };
            } else {
              _ou_type[item.type.name].children.push({
                _id: item._id,
                id: item.id,
                label: item.name,
                data: item.image_sq,
                tag: item?.type?.tag,
                active: item?.active,
                children: this.filterChildrensWihFilter(item?.children, item._id, tags),
              });
            }

          }
        }


      });

      var firstNode: { label: string; expanded: boolean; tag: string; data: string; children: any[] } = {
        label: "الجهات المشاركة",
        expanded: false,
        tag: 'Organisational Units',
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [],
      };

      for (const key in _ou_type) {
        if (_ou_type.hasOwnProperty(key)) {
          // Use the key and access the corresponding value
          if (_ou_type[key]) {
            firstNode.children.push(_ou_type[key]);
            console.log(`Key: ${key}, Value: ${_ou_type[key]}`);
          }
        }
      }

      treedata = [firstNode]
      return treedata

    } catch (error) {
      console.log(error)
    }
  }

  async getOrgUnitsMainPage(tags: any[]): Promise<any> {
    try {
      if (this.ouChilds == undefined) {
        this.ouChilds = await this.dataService.getData(`ou/ouChilds`);
      }

      const response = this.ouChilds

      if (response.error) return
      var treedata: TreeNode[] = [];

      var level1 = response.data;

      var _ou_type: { [key: string]: any } = {};

      const types = await this.dataService.getData("ou-type");

      types.data.forEach((type: any) => {
        if (type.tag == "Ministries/Entities") {
          _ou_type[type.name] = {
            _id: type._id,
            id: null,
            label: type.name,
            data: type.icon,
            tag: type.tag,
            expanded: false,
            children: []
          }
        }
      })

      console.log("ou types", _ou_type);

      level1.forEach((item: any) => {
        if (item.type && item?.type?.tag == "Ministries/Entities") {

          if (!_ou_type[item.type.name]) {
            _ou_type[item.type.name] = {
              _id: item.type._id,
              label: item.type.name,
              data: item.type.icon,
              tag: item?.type?.tag,
              expanded: false,
              children: [
                {
                  _id: item._id,
                  id: item.id,
                  label: item.name,
                  data: item.image_sq,
                  tag: item?.type?.tag,
                  active: item?.active,
                  children: this.filterChildrensWithMainPage(item?.children, item._id, tags),
                },
              ],
            };
          } else {
            _ou_type[item.type.name].children.push({
              _id: item._id,
              id: item.id,
              label: item.name,
              data: item.image_sq,
              tag: item?.type?.tag,
              active: item?.active,
              children: this.filterChildrensWithMainPage(item?.children, item._id, tags),
            });
          }

        }

      });

      var firstNode: { label: string; expanded: boolean; tag: string; data: string; children: any[] } = {
        label: "الجهات المشاركة",
        expanded: false,
        tag: 'Organisational Units',
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [],
      };

      for (const key in _ou_type) {
        if (_ou_type.hasOwnProperty(key)) {
          // Use the key and access the corresponding value
          if (_ou_type[key]) {
            firstNode.children.push(_ou_type[key]);
            console.log(`Key: ${key}, Value: ${_ou_type[key]}`);
          }
        }
      }

      treedata = [firstNode]
      return treedata

    } catch (error) {
      console.log(error)
    }
  }

  async getLatesOrgs(): Promise<any> {
    try {
      if (this.ouChilds_removeInactive == undefined) {
        this.ouChilds_removeInactive = await this.dataService.getData(`ou/ouChilds?removeInactive=true`);
      }
      const response = this.ouChilds_removeInactive;

      if (response.error) return
      var treedata: TreeNode[] = [];

      var level1 = response.data;

      var _ou_type: { [key: string]: any } = {};


      level1.forEach((item: any) => {
        if (item.type) {
          if (!_ou_type[item.type.name]) {
            _ou_type[item.type.name] = {
              _id: item.type._id,
              label: item.type.name,
              data: item.type.icon,
              tag: item?.type?.tag,
              expanded: false,
              children: [
                {
                  _id: item._id,
                  id: item.id,
                  label: item.name,
                  data: item.image_sq,
                  tag: item?.type?.tag,
                  active: item?.active,
                  children: this.filterChildrens(item?.children, item._id),
                },
              ],
            };
          } else {
            _ou_type[item.type.name].children.push({
              _id: item._id,
              id: item.id,
              label: item.name,
              data: item.image_sq,
              tag: item?.type?.tag,
              active: item?.active,
              children: this.filterChildrens(item?.children, item._id),
            });
          }
        }

      });

      var firstNode: { label: string; expanded: boolean; tag: string; data: string; children: any[] } = {
        label: "الجهات المشاركة",
        expanded: false,
        tag: 'Organisational Units',
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [],
      };

      for (const key in _ou_type) {
        if (_ou_type.hasOwnProperty(key)) {
          // Use the key and access the corresponding value
          if (_ou_type[key]) {
            firstNode.children.push(_ou_type[key]);
            console.log(`Key: ${key}, Value: ${_ou_type[key]}`);
          }
        }
      }

      treedata = [firstNode]
      this.treedata = treedata;
      return treedata

    } catch (error) {
      console.log(error)
    }
  }

  extractOUChildren(nodes: TreeNode[], label: any): any {
    let comparer;
    let ouToExtract;
    let hasId: boolean = false;

    if (typeof label === 'string') {
      comparer = label;
    } else {
      comparer = label._id;
      hasId = true;
    }

    for (let node of nodes) {
      console.log('NODE', node);
      if (hasId) {
        if (node._id == comparer) {
          return node;
        }
      } else {
        if (node.label == comparer) {
          return node;
        }
      }
      if (node.children) {
        ouToExtract = this.extractOUChildren(node.children, label);
        if (ouToExtract) {
          return ouToExtract;
        }
      }
    }
    return ouToExtract;
  }

  childrenContains(nodes: TreeNode[], label: string): boolean {
    let result = false;
    for (let node of nodes) {
      if (node != undefined && node != null) {
        if (node.label == label) {
          return true;
        }

        if (node.children) {
          result = this.childrenContains(node.children, label);
          if (result) {
            return result;
          }
        }
      }
    }
    return result;
  }

  childrenContainsId(nodes: TreeNode[], id: string): boolean {
    let result = false;
    for (let node of nodes) {
      if (node != undefined && node != null) {
        if (node._id == id) {
          return true;
        }
        if (node.children) {
          result = this.childrenContainsId(node.children, id);
          if (result) {
            return result;
          }
        }
      }
    }
    return result;
  }

  findById(nodes: any[], id: string): any {
    let result;
    for (let node of nodes) {
      if (node != undefined && node != null) {
        if (node.id == id) {
          return node;
        }
        if (node.children) {
          result = this.findById(node.children, id);
          if (result) {
            return result;
          }
        }
      }
    }
    return result;
  }

  findBy_Id(nodes: any[], id: string): any {
    let result;
    for (let node of nodes) {
      if (!!node && !!node._id && node._id == id) {
        return node;
      }
      if (!!node.children) {
        result = this.findBy_Id(node.children, id);
        if (result) {
          return result;
        }
      }
    }
    return result;
  }


  convertToTreeNode(items: any[]): any[] {
    const itemMap: { [id: string]: any } = {};
    const roots: any[] = [];

    // First, create a map of items by their IDs
    items.forEach(item => {
      itemMap[item._id] = item;
    });

    // Then, assign children to their parents
    items.forEach(item => {
      if (item.parent && item.parent in itemMap) {
        const parent = itemMap[item.parent];
        if (!parent.children) {
          parent.children = [];
        }
        item.label = item.name;
        item.data = item.image
        parent.children.push(item);
      } else {
        item.label = item.name;
        item.data = item.image
        roots.push(item);
      }
    });

    return roots;
  }


  filterChildrens(children: any[], _id: string) {

    var tree: any[] = []

    var level1 = children.filter((item: any) => { return item.parent == _id });

    if (level1.length > 0) {

      level1.forEach(async (item: any) => {
        tree.push({
          _id: item._id,
          id: item.id,
          label: item?.type?.tag == 'Branches' ? `${item.name} (${item?.location?.name})` : item.name,
          active: item?.active,
          data: item.image_sq,
          tag: item?.type?.tag,
          children: this.filterChildrens(children, item._id)
        })
      })
    }

    tree.sort((a: any, b: any) => a.id - b.id)

    return tree;
  }


  filterChildrensWihFilter(children: any[], _id: string, tags: any[]) {

    var tree: any[] = []

    var level1 = children.filter((item: any) => { return item.parent == _id });

    if (level1.length > 0) {
      level1.forEach(async (item: any) => {
        if (item.type && tags.includes(item?.type?.tag))
          tree.push({
            _id: item._id,
            id: item.id,
            label: item.name,
            data: item.image_sq,
            tag: item?.type?.tag,
            active: item?.active,
            children: this.filterChildrensWihFilter(children, item._id, tags)
          })
      })
    }

    tree.sort((a: any, b: any) => a.id - b.id)

    return tree;

  }

  filterChildrensWithMainPage(children: any[], _id: string, tags: any[]) {

    var tree: any[] = []

    var level1 = children.filter((item: any) => { return item.parent == _id });

    if (level1.length > 0) {
      level1.forEach(async (item: any) => {
        if (item.type && tags.includes(item?.type?.tag) && item?.type?.tag == "Ministries/Entities")
          tree.push({ _id: item._id, active: item?.active, id: item.id, label: item.name, data: item.image_sq, tag: item?.type?.tag, children: this.filterChildrensWihFilter(children, item._id, tags) })
      })
    }

    tree.sort((a: any, b: any) => a.id - b.id)

    return tree;

  }

}
